import { FunctionComponent } from "react";
import urljoin from "url-join";
import { siteConfig } from "../../siteConfig";

export type SEOProps = {
  title: string;
  description?: string;
  image?: string;
  path: string;
};

export const SEO: FunctionComponent<SEOProps> = ({
  title,
  description,
  image = siteConfig.siteLogo,
  path,
}) => {
  const url = urljoin(siteConfig.siteUrl, path);
  const isBlogPost = path.match(/blog/);
  image = urljoin(siteConfig.siteUrl, image);

  const schemaOrgJSONLD = [
    {
      "@context": "http://schema.org",
      "@type": "WebSite",
      url: url,
      name: title,
      alternateName: siteConfig.siteTitleAlt ? siteConfig.siteTitleAlt : "",
    },
  ];
  if (isBlogPost) {
    schemaOrgJSONLD.push(
      {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        // @ts-expect-error Schema validation fails
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            item: {
              "@id": url,
              name: title,
              image,
            },
          },
        ],
      },
      {
        "@context": "http://schema.org",
        "@type": "BlogPosting",
        url: url,
        name: title,
        alternateName: siteConfig.siteTitleAlt || "",
        headline: title,
        image: {
          "@type": "ImageObject",
          url: image,
        },
        description,
      }
    );
  }
  return (
    <>
      <title>{title}</title>
      <html lang="en"></html>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin=""
      ></link>
      <meta name="description" content={description} />
      <meta name="image" content={image} />
      <link rel="canonical" href={url} />
      {/* <html className="dark" /> */}

      {/* Schema.org tags */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrgJSONLD)}
      </script>

      {/* OpenGraph tags */}
      <meta property="og:url" content={url} />
      {isBlogPost ? (
        <meta property="og:type" content="article" />
      ) : (
        <meta property="og:type" content="website" />
      )}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta
        property="fb:app_id"
        content={siteConfig.siteFBAppID ? siteConfig.siteFBAppID : ""}
      />

      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:creator"
        content={siteConfig.userTwitter ? siteConfig.userTwitter : ""}
      />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </>
  );
};
